/* Documents */
import ThumbAutheticate from 'assets/images/authenticate-tutorial.png';
import ThumbDocuments from 'assets/images/documents-tutorial.png';

/* Dr. Licita */
import ThumbCustomizedKeywordSearch from 'assets/images/tutorial-dr-licita-customized-keyword-search.png';
import ThumbDocumentKeyword from 'assets/images/tutorial-dr-licita-document-keyword.png';
import ThumbDocument from 'assets/images/tutorial-dr-licita-document.png';

/* Conlicitaseg */
import ThumbBidGarantee from 'assets/images/tutorial-conlicitaseg-garantia-de-proposta.png';
import ThumbPerformanceGarantee from 'assets/images/tutorial-conlicitaseg-garantia-de-execucao.png';

export interface TutorialItem {
  title: string;
  video: string;
  thumb: string;
  requiresAlfaTester?: boolean;
}

export type TutorialsData = Record<string, TutorialItem[]>;

export const tutorialsData: TutorialsData = {
  documents: [
    {
      title: 'Gerenciar Documentos na prática',
      video: 'https://player.vimeo.com/video/1142414647',
      thumb: ThumbDocuments,
    },
    {
      title: 'Autenticar documentos',
      video: 'https://player.vimeo.com/video/1136577672',
      thumb: ThumbAutheticate,
    },
  ],
  drlicita: [
    {
      title: 'Criar petição através da busca personalizada com palavra-chave',
      video: 'https://player.vimeo.com/video/1136497146',
      thumb: ThumbCustomizedKeywordSearch,
    },
    {
      title: 'Criar petição através de documento com palavra-chave',
      video: 'https://player.vimeo.com/video/1136497393',
      thumb: ThumbDocumentKeyword,
    },
    {
      title: 'Criar petição utilizando somente um documento',
      video: 'https://player.vimeo.com/video/1136497472',
      thumb: ThumbDocument,
    },
  ],
  conlicitaseg: [
    {
      title: '',
      video: 'https://player.vimeo.com/video/1202269940',
      thumb: ThumbBidGarantee,
    },
    {
      title: '',
      video: 'https://player.vimeo.com/video/1202269939',
      thumb: ThumbPerformanceGarantee,
    },
  ],
};

export type TutorialDataKey = keyof typeof tutorialsData;
